
const EVENTS = {
    ASPECT_RATIO_CHANGE: "lesson:aspect_ratio:change",
    AVAILABILITY_CHANGE: "lesson:availability:change",
};

export default EVENTS
